// Welle 4.5, R3 Punkt 1 (BACKLOG §5 Welle-4 (g)): gemeinsame Datei-Eingabe-
// Logik für Dokument-Modale, vorher als ~70 Zeilen dupliziert zwischen
// `Pages/Projects/Modals/DistributeDocument.vue` und
// `Shared/Components/Documents/Modals/Create.vue` (Grösse/Endung-Prüfung,
// Auswahl-Button, Entfernen-Button, Drop-Injektion).
//
// Options-API-Mixin, kein neues Komponenten-Interface — beide Hosts behalten
// ihr eigenes Markup und binden `@click`/`@change`/`@file` weiterhin selbst.
// Die Branding-Werte (`core.max_document_upload_size`,
// `core.document_file_upload_mimes`) kommen unverändert aus den bestehenden
// Shared Props, kein neuer Backend-Pfad.
//
// `setFile(file)` ist der einzige Erweiterungspunkt: die Datei landet in
// `DistributeDocument.vue` in `this.file` (Default hier), in
// `Shared/Components/Documents/Modals/Create.vue` in `this.form.file`
// (`useForm`) — der Host überschreibt die Methode entsprechend, Options-API-
// Mixins lassen Komponenten-Methoden mit demselben Namen gewinnen.
const FALLBACK_MAX_BYTES = 20 * 1024 * 1024;
const FALLBACK_MIMES = "pdf,docx,xlsx";

export default {
    computed: {
        maxSizeInMb() {
            const bytes =
                this.$page.props.branding?.max_document_upload_size || FALLBACK_MAX_BYTES;
            return Math.round(bytes / 1024 / 1024);
        },
        documentMimes() {
            return (
                this.$page.props.branding?.document_file_upload_mimes || FALLBACK_MIMES
            );
        },
        allowedMimesAccept() {
            return this.documentMimes
                .split(",")
                .map((m) => `.${m.trim().toLowerCase()}`)
                .join(",");
        },
    },
    methods: {
        setFile(file) {
            this.file = file;
        },
        selectNewFile() {
            this.$refs.file.click();
        },
        clearFileInput() {
            if (this.$refs.file?.value) {
                this.$refs.file.value = null;
                this.fileUploaded = null;
                this.setFile(null);
            }
        },
        updateFileUploaded() {
            const selectedFile = this.$refs.file.files[0];
            if (!selectedFile) return;

            const maxBytes =
                this.$page.props.branding?.max_document_upload_size || FALLBACK_MAX_BYTES;
            if (selectedFile.size > maxBytes) {
                this.$notify({
                    group: "error",
                    title: "actions.error",
                    text: "documents.fileTooBig",
                });
                this.clearFileInput();
                return;
            }

            const fileExt = selectedFile.name.split(".").pop().toLowerCase();
            const mimes = this.documentMimes
                .split(",")
                .map((m) => m.trim().toLowerCase());
            if (!mimes.includes(fileExt)) {
                // W3 (Fix-Runde 1): "documents.fileInfo" erwartet
                // Interpolationsparameter ({size}/{extensions}) — als
                // Notify-Text ohne `params` blieben die Platzhalter
                // unaufgelöst im Toast sichtbar. Eigener, platzhalterfreier
                // Key.
                this.$notify({
                    group: "error",
                    title: "actions.error",
                    text: "documents.fileTypeInvalid",
                });
                this.clearFileInput();
                return;
            }

            this.fileUploaded = selectedFile.name;
            this.setFile(selectedFile);
        },
        onDropFile(file) {
            const dt = new DataTransfer();
            dt.items.add(file);
            this.$refs.file.files = dt.files;
            this.$refs.file.dispatchEvent(new Event("change", { bubbles: true }));
        },
        // W2 (Fix-Runde 1): Host-Bindung für `FileDropzone`s `@reject` —
        // eine per Drop abgelegte, nicht zur `accept`-Liste passende Datei
        // zeigt dieselbe Meldung wie eine per Dialog ausgewählte falsche
        // Endung.
        onFileRejected() {
            this.$notify({
                group: "error",
                title: "actions.error",
                text: "documents.fileTypeInvalid",
            });
        },
    },
};
